document.addEventListener( 'DOMContentLoaded', ( event ) => {
} );
